onDomReady(function () {
   let parents = $$('.parent');
   let children = $$('.child');

   for (let i = 0; i < parents.length; i++) {
      parents[i].addEvent('click', function () {
         let index = parents.indexOf(this);
         children[index].toggleClass('hidden');

         let downCaret = this.getChildren('span i')[0];
         downCaret.toggleClass('hidden');
      });

      children[i].addEvent('click', function () {
         this.toggleClass('hidden');

         let index = children.indexOf(this);
         let downCaret = parents[index].getChildren('span i')[0];
         downCaret.toggleClass('hidden');
      });
   }
});
